module.exports = __webpack_public_path__ + "img/fy3.86fa7d76.png";